import React from "react";
import { useNavigate } from "react-router-dom";

export const WithBackButton = ({ component }) => {
  const navigate = useNavigate();

  return (
    <div className="goBackBtn">
      {component}
      <button className="goBackBtn-btn" onClick={() => navigate("/")}>
        Powrót do Strony Głównej
      </button>
    </div>
  );
};
